import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import { noop } from 'src/utils'

export class PillButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.any,
    color: PropTypes.oneOf(['blue', 'red']),
  }

  static defaultProps = {
    className: '',
    onClick: noop,
    children: null,
    color: 'red',
  }

  get className() {
    const { className, color } = this.props
    return c('im-pill-button', color, className)
  }

  render() {
    const { className } = this
    const { children, onClick } = this.props
    return (
      <div onClick={onClick} className={className}>
        {children}
      </div>
    )
  }
}

export default PillButton
